<script setup lang="ts">
defineProps<{ title: string; subtitle: string }>()
</script>

<script lang="ts">
export default {}
</script>

<template>
  <div
    class="text-dark-text-100 dark:text-light-text-100 text-heading-3 mt-6 mb-4 tablet-portrait:mb-5 ps-1 tablet-portrait:ps-4 tablet-portrait:pe-2"
  >
    <h1 class="whitespace-normal">{{ title }}</h1>
    <h2 class="font-semibold">{{ subtitle }}</h2>
  </div>
</template>
